import React, { lazy } from 'react';

const PrintAddendumC = lazy(() => import('../ebisprint/addc/PrintAddendumC'));
const PrintMjc = lazy(() => import('../ebisprint/mjc/PrintMjc'));
const PrintPlayerAddendumF = lazy(
  () => import('../ebisprint/playerletters/PrintPlayerAddendumF')
);
const CBTAssessmentReport = lazy(
  () => import('../ebisprint/reports/MJC/payroll/CBTAssessmentReport')
);
const CapitalizedPaymentReport = lazy(
  () => import('../ebisprint/reports/MJC/CapitalizedPaymentsReport')
);
const PrintPlayerAddendumG = lazy(
  () => import('../ebisprint/playerletters/PrintPlayerAddendumG')
);
const PrintPlayerLetterMaster = lazy(
  () => import('../ebisprint/playerletters/printPlayerLetterMaster')
);

export default [
  {
    path: 'ebisprint',
    children: [
      {
        path: '/ebisprint/addc/:mncCId',
        element: <PrintAddendumC />,
      },
      {
        path: '/ebisprint/mjc-print/:mjcId',
        element: <PrintMjc />,
      },
      {
        path: '/ebisprint/player-letter-print',
        element: <PrintPlayerLetterMaster />,
      },
      {
        path: '/ebisprint/addf',
        element: <PrintPlayerAddendumF />,
      },
      {
        path: '/ebisprint/addg',
        element: <PrintPlayerAddendumG />,
      },
      {
        path: '/ebisprint/cbt-assessment-report',
        element: <CBTAssessmentReport />,
      },
      {
        path: '/ebisprint/capitalized-payments-report',
        element: <CapitalizedPaymentReport />,
      },
    ],
  },
];
